import fire from '../utils/firebase';
import { getAuth, createUserWithEmailAndPassword, signInWithEmailAndPassword} from "firebase/auth";

export const signup = async (props) => {
    
    const auth = getAuth(fire);
    console.log('auth ', props.email)

    createUserWithEmailAndPassword(auth, props.email, props.password)
        .then((userCredential) => {
            // signed up and signed in 
            const user = userCredential.user;
            console.log('user created and signed in', user)
            return user;
        })
        .catch((error) => {
            const errorCode = error.code;
            const errorMessage = error.message;
            console.log('error creating user', errorCode, errorMessage)
            return errorMessage
        })
}

export const login = async (props) => {
    
    return new Promise((resolve, reject) => {
    const auth = getAuth(fire);

    signInWithEmailAndPassword(auth, props.email, props.password)
        .then((userCredential) => {
            // signed in 
            const user = userCredential.user;
            console.log('user created and signed in', user)
            resolve(user);
        })
        .catch(async (error) => {
            if(error.code === "auth/invalid-email") {
                reject(new Error("Invalid email."));
            } else if (error.code === "auth/user-disabled") {
                reject(new Error("This user has been disabled."));
            } else if (error.code === "auth/user-not-found") {
                reject(new Error("This user has not been found."));
            } else if (error.code === "auth/wrong-password") {
                reject(new Error("This password is incorrect."));
            } else {
                reject(new Error("Error logging in. Try again later."));
            }
        })
    })
}

export const logout = async (props) => {
    
    const auth = getAuth(fire);

    auth.signOut().then(() => {
            // signed out
            console.log('user logged out')
        })
        .catch((error) => {
            const errorCode = error.code;
            const errorMessage = error.message;
            console.log('error logging out user', errorCode, errorMessage)
            return errorMessage
        })
}